import { Box, Tag } from '@factorialco/deprecated-design-system'
import { TrainingCompetencyFragment } from 'generated/resources/graphql'

interface Props {
  competencies: TrainingCompetencyFragment[]
}
export const CompetenciesTags = ({ competencies }: Props) => {
  if (competencies.length === 0) return <Tag inline>{'-'}</Tag>

  const slicedCompetencies = competencies.slice(0, 2)

  const extraCompetencies = competencies.length - slicedCompetencies.length

  return (
    <Box gap="s4" flexDirection="row" flexWrap="wrap">
      {slicedCompetencies.map((competency, index) => (
        <Tag key={index}>{competency.name}</Tag>
      ))}
      {extraCompetencies > 0 && <Tag key={slicedCompetencies.length}>+ {extraCompetencies}</Tag>}
    </Box>
  )
}
